import { render, staticRenderFns } from "./FormInputUseText.vue?vue&type=template&id=63e2d38f&scoped=true&lang=pug"
import script from "./FormInputUseText.vue?vue&type=script&lang=ts"
export * from "./FormInputUseText.vue?vue&type=script&lang=ts"
import style0 from "./FormInputUseText.vue?vue&type=style&index=0&id=63e2d38f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e2d38f",
  null
  
)

export default component.exports